var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',[_c('b-row',[_c('div',{staticClass:"p-3"},[_vm._v(" "+_vm._s(_vm.$t("errors.order-fail"))+" ")])]),_c('ui-posts',{model:{value:(_vm.posts),callback:function ($$v) {_vm.posts=$$v},expression:"posts"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }